import axios from "../utils/axios"
export const ArticleService={
    getJournalArticles:async(page,limit,searchTerm='',documentId,projectId,updatedAtDate,status,sortOrder)=>{
        try {
            const response = await axios.get(`/api/articles/getProjectJournalArticles?page=${page}&limit=${limit}&searchTerm=${searchTerm}&updatedAtDate=${updatedAtDate}&status=${status}&documentId=${documentId}&projectId=${projectId}&sortOrder=${sortOrder}`)
            if(response?.data?.success){
                 return response.data
            }
        } catch (error) {
            throw new Error(error?.response?.data?.message || "Failed to fetch journal articles list")

        }
    },

    getJournals:async(documentId,projectId)=>{
        try {
            const response = await axios.get(`/api/articles/document-journals?documentId=${documentId}&projectId=${projectId}`)
            if(response?.data?.success){
                 return response.data
            }
        } catch (error) {
            throw new Error(error?.response?.data?.message || "Failed to fetch project journal list")

        }
    },

    addJournals:async(formData)=>{
        try {
            const response = await axios.post(`/api/articles/document-journals`,formData,{
                headers: {
                    "Content-Type": "application/json",
                },
            })
            if(response?.data?.success){
                return response.data
            }
        } catch (error) {
            const errorResponse=error?.response?.data;
            throw errorResponse.errors
        }
    },

    getJournalDetails:async(articleId)=>{
        try {
            const response = await axios.get(`/api/articles/${articleId}`)
            if(response?.data?.success){
                 return response.data
            }
        } catch (error) {
            throw new Error(error?.response?.data?.message || "Failed to fetch project journal list")

        }
    },

    updateArticleStatus:async(id,status)=>{
        try {
            const response = await axios.patch(`/api/articles/${id}/status`,{status:status},{
                headers:{
                    "Content-Type": "application/json",
                }
            });
            if(response?.data?.success){
                return true;
            }else{
                throw new Error(response?.message || "Failed to update client");
            }
        } catch (error) {
            // const errorResponse = error.response.data;
            throw error.response?.data;
        }
    },

    addJournalsArticles:async(formData)=>{
        try {
            const response = await axios.post(`/api/articles/createProjectJournalArticle`,formData,{
                headers: {
                    "Content-Type": "application/json",
                },
            })
            if(response?.data?.success){
                return response.data
            }
        } catch (error) {
            throw new Error(
                error?.response?.data?.message ||
                error?.message ||
                "Failed to add journal article."
            );
        }
    },

    getProjectJournalArticlesByArticleID:async(articleId)=>{
        try {
            const response = await axios.get(`/api/articles/getProjectJournalArticles/${articleId}`);
            if(response?.data?.success){
                return response?.data?.data;
            }else{
                throw new Error(response?.message || "Failed to get journal article");
            }
        } catch (error) {
            throw new Error(error?.response?.data?.message || "Failed to get journal article");
        }
    },
    
    updateProjectJournalArticlesByArticleID:async(articleId,formData)=>{
        try {
            const response = await axios.patch(`/api/articles/project-journal-articles/${articleId}`,formData,{
                headers:{
                    "Content-Type": "application/json",
                }
            });
            if(response?.data?.success){
                return true;
            }else{
                throw new Error(response?.message || "Failed to update jounal article");
            }
        } catch (error) {
            throw new Error(
                error?.response?.data?.message ||
                error?.message ||
                "Failed to update journal article."
            );
        }
    },

    deleteProjectJournal: async (journalId) => {
        try {
            const response = await axios.delete(
            `/api/articles/document-journals/${journalId}`
            );

            return response.data;
        } catch (error) {
            throw new Error(
                error?.response?.data?.message ||
                error?.message ||
                "Failed to delete journal."
            );
        }
    },
}